'use client'

import '@tamagui/core/reset.css'
import '@tamagui/polyfill-dev'

if (process.env.NODE_ENV === 'production') {
  require('../../public/tamagui.css')
}

import { config as configBase } from '@tamagui/config'
import { NextThemeProvider, useRootTheme } from '@tamagui/next-theme'
import { PortalProvider } from '@tamagui/portal'
import { useServerInsertedHTML } from 'next/navigation'
import React from 'react'
import { StyleSheet } from 'react-native'
import { createTamagui, TamaguiProvider as TamaguiProviderOG } from '@tamagui/core'

import Tamagui from '../../tamagui.config'

export const TamaguiProvider = ({ children }: { children: React.ReactNode }) => {
  const [theme, setTheme] = useRootTheme()

  useServerInsertedHTML(() => {
    // @ts-ignore
    const rnwStyle = StyleSheet.getSheet()
    return (
      <>
        <style dangerouslySetInnerHTML={{ __html: rnwStyle.textContent }} id={rnwStyle.id} />
        <style
          dangerouslySetInnerHTML={{
            __html: Tamagui.getCSS({
              // if you are using "outputCSS" option, you should use this "exclude"
              // if not, then you can leave the option out
              exclude: process.env.NODE_ENV === 'production' ? 'design-system' : null,
            }),
          }}
        />
      </>
    )
  })

  return (
    <NextThemeProvider
      onChangeTheme={(next) => {
        setTheme(next as any)
      }}
    >
      <TamaguiProviderOG config={Tamagui} themeClassNameOnRoot defaultTheme={theme || 'dark'}>
        <PortalProvider shouldAddRootHost>
          {children}
        </PortalProvider>
      </TamaguiProviderOG>
    </NextThemeProvider>
  )
}
